module.exports = __webpack_public_path__ + "1.5.0-unryo/img/redis.4aaff929.svg";